import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Card,
  CardContent,
  useTheme,
  useMediaQuery,
  Typography,
  Avatar,
} from '@mui/material';
import {
  CarouselContainer,
  CarouselWrapper,
  classes,
  PaginationDot,
} from './utils';
import { lightPalette } from '../../../../theme';
import testimonyImg1 from '../../../../assets/testimony-assets/testimony_img1.png';
import testimonyImg2 from '../../../../assets/testimony-assets/testimony_img2.png';
import testimonyImg3 from '../../../../assets/testimony-assets/testimony_img3.png';

const BlogCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying] = useState(true);
  const carouselRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const posts = [
    {
      id: 1,
      blogWriterName: 'P. D. Goenka',
      blogWriterRole: 'Founder at P.D. Goenka Associates',
      image: testimonyImg1,
      blogContent:
        '"Docu Transcribe has made our invoicing simple and efficient. It saves us time and helps avoid mistakes. Now, we can process invoices faster without worrying about errors."',
    },
    {
      id: 2,
      blogWriterName: 'Tirth Shah',
      blogWriterRole: 'Co-Founder at Tipsons Financial Services',
      image: testimonyImg2,
      blogContent:
        '"We used to spend hours going through credit card statements, trying to spot errors. Now, Docu Transcribe does it for us, making work so much easier. It has improved accuracy and saved us a lot of time."',
    },
    {
      id: 3,
      blogWriterName: 'Manoj Sanas',
      blogWriterRole: 'CEO at Brain4You Consulting',
      image: testimonyImg3,
      blogContent:
        '"Tracking expenses was a headache before we started using Docu Transcribe. Now, everything is clear and well-organized, and we can approve reimbursements much faster. It has made financial management stress-free."',
    },
  ];

  const visiblePosts = isMobile ? 1 : 1;
  const maxIndex = posts.length - visiblePosts;

  const handleNext = () => {
    setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  useEffect(() => {
    let interval;
    if (isPlaying) {
      interval = setInterval(() => {
        handleNext();
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [isPlaying, currentIndex]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowLeft') handlePrev();
    if (e.key === 'ArrowRight') handleNext();
  };

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <CarouselContainer
      role="region"
      aria-label="Featured Posts Carousel"
      onKeyDown={handleKeyDown}
      tabIndex="0"
      padding="0px !important"
    >
      <CarouselWrapper
        ref={carouselRef}
        sx={{
          transform: `translateX(-${currentIndex * (100 / visiblePosts)}%)`,
        }}
      >
        {posts?.map((post) => (
          <Card
            key={post.id}
            sx={{
              flex: `0 0 ${100 / visiblePosts}%`,
              maxWidth: `${100 / visiblePosts}%`,
            }}
            className={classes.blogCard}
          >
            <CardContent className={classes.blogCardContent}>
              <Box className={classes.blogCardContentBox}>
                <Box className={classes.blogTextBox}>
                  <Typography
                    variant="body1"
                    color={lightPalette.secondaryWhite.main}
                    sx={{
                      fontWeight: 400,
                    }}
                  >
                    {post.blogContent}
                  </Typography>
                </Box>
                <Box className={classes.blogProfileMainBox}>
                  <Avatar
                    variant="square"
                    src={`${post?.image}`}
                    alt="contact image"
                    className={classes.avatarStyle}
                  />
                  <Box component="div" className={classes.profileDetails}>
                    <Box component="div" className={classes.profileName}>
                      {post.blogWriterName}
                    </Box>

                    {post.blogWriterRole}
                  </Box>
                </Box>
              </Box>
            </CardContent>
          </Card>
        ))}
      </CarouselWrapper>

      <Box className={classes.paginationDotBox}>
        {posts.slice(0, maxIndex + 1).map((_, index) => (
          <PaginationDot
            key={index}
            active={currentIndex === index}
            onClick={() => handleDotClick(index)}
            role="button"
            aria-label={`Go to slide ${index + 1}`}
            tabIndex="0"
          />
        ))}
      </Box>
    </CarouselContainer>
  );
};

export default BlogCarousel;
